import moment from "moment";

export const today = moment().startOf("day").format("DD.MM.YYYY").toString();
export const yesterday = moment().startOf("day").subtract(1, "day").format("DD.MM.YYYY").toString();
export const firstDayCurrentWeek = moment().startOf("day").startOf("week").format("DD.MM.YYYY").toString();
export const lastDayCurrentWeek = moment().startOf("day").format("DD.MM.YYYY").toString();
const firstDayLastWeek = moment().startOf("day").startOf("week").subtract(1, "week").format("DD.MM.YYYY").toString();
const lastDayLastWeek = moment().startOf("day").endOf("week").subtract(1, "week").format("DD.MM.YYYY").toString();
const sevenDayAgo = moment().startOf("day").subtract(6, "day").format("DD.MM.YYYY").toString();
export const firstDayCurrentMonth = moment().startOf("day").startOf("month").format("DD.MM.YYYY").toString();
const firstDayLastMonth = moment().startOf("day").subtract(1, "month").startOf("month").format("DD.MM.YYYY").toString();
const lastDayLastMonth = moment().startOf("day").subtract(1, "month").endOf("month").format("DD.MM.YYYY").toString();

export const getDatePickerDateValue = (startDate, endDate) => {
    if (today === startDate && today === endDate) {
        return "Сегодня";
    }
    if (yesterday === startDate && yesterday === endDate) {
        return "Вчера";
    }
    if (firstDayCurrentWeek === startDate && lastDayCurrentWeek === endDate) {
        return "С начала недели";
    }
    if (firstDayLastWeek === startDate && lastDayLastWeek === endDate) {
        return "Прошлая неделя";
    }
    if (today === endDate && sevenDayAgo === startDate) {
        return "Последние 7 дней";
    }
    if (firstDayCurrentMonth === startDate && today === endDate) {
        return "Текущий месяц";
    }
    if (firstDayLastMonth === startDate && lastDayLastMonth === endDate) {
        return "Прошлый месяц";
    }
    if (
        startDate === moment().startOf("day").subtract(1, "month").format("DD.MM.YYYY").toString() &&
        today === endDate
    ) {
        return "Последний месяц";
    }
    return `${startDate} - ${endDate}`;
};
